import { createApp, defineAsyncComponent } from "vue";
import App from "./app.vue";
import { router } from "./router";
import { store } from "./store";
import api from "./api.js";
import apiUpload from "./apiUpload.js";
import { install } from "vue3-recaptcha-v2";

//import VueAxios from 'vue-axios'
import i18n from "../../i18n";
//import "./bootstrap.js";
//import GoTop from '@inotom/vue-go-top';
import Toast, { useToast } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

import VueSimpleAlert from "vue3-simple-alert-next";
import { parseErrorResponse, isValidationError, isServerError } from './utils/errorHandler.js';
import * as errorNotification from './utils/errorNotification.js';
import "../css/font-awesome/fontawesome.css";
// import'../'
import "../css/font-awesome/solid.css";
import "../css/font-awesome/brands.css";
//axios.defaults.baseURL = 'http://127.0.0.1:3030'

//i18n globally: https://stackoverflow.com/questions/66732739/internationalization-for-vue-3-vite-with-i18n

window.axios = api;
window.axiosUpload = apiUpload;
axios.interceptors.response.use(
  (response) => {
    if (response.headers["content-type"].startsWith("application/json")) {
      return response;
    } else {
      //store.dispatch("logout");
      //router.push("/login");
      //window.location.replace("/login");
      return Promise.reject(response);
    }
  },
  (error) => {
    if (!error.response) {
      // Network error - show notification
      errorNotification.showError({
        response: {
          status: 0,
          data: {
            code: null,
            message: "Connection to the server failed. Please check your internet connection."
          }
        }
      }, app.__vue_app__.config.globalProperties.$i18n);
      return Promise.reject(error);
    }

    // Handle 401 specially (redirect to login)
    if (error.response.status === 401) {
      store.dispatch("logout");
      router.push("/login");
      return Promise.reject(error);
    }

    // For other errors, parse but don't show notification here
    // Let components decide whether to show notification or handle inline
    // This maintains backward compatibility

    return Promise.reject(error);
  }
);

const app = createApp(App).use(i18n);

app.config.errorHandler = function (err, vm, info) {
  console.log("caught");
  console.error(err, vm, info);
};

window.onerror = function (message, source, line, column, error) {
  console.log("caught");
};

app.config.globalProperties.$datasetColor = [
  "blue",
  "#eaaa00",
  "green",
  "red",
  "indigo",
  "#85603F",
  "#99154e",
  "#A03C78",
  "#ce7e00",
  "#5C4D4D",
  "#abce30",
  "#1e3163",
  "#ffd043",
  "#00d982",
  "#0f3053",
  "#1102ab",
  "#361d32",
  "#dec6b6",
  "#df5286",
  "#091a98",
  "#760091",
  "#ae0082",
  "#d6006d",
  "#f20f56",
  "#ff7c23",
  "#ffa600",
  "#D8CBC7",
  "#CC3F0C",
  "#9A6D38",
  "#18314F",
  "#0D0630",
];

app.config.globalProperties.$sewageColor = [ "grey" , "green" , "yellow" , "red"]
app.config.globalProperties.$sectorColor = [
  "#FF5733", // vivid red-orange
  "#33C1FF", // bright blue
  "#28A745", // vivid green
  "#FFC300", // bright yellow
  "#C70039", // strong red
  "#8D33FF", // vibrant purple
  "#FF33A8", // hot pink
  "#b6bdb7ff", // grey
  "#FF8F33", // orange
  "#335BFF"  // electric blue
  ]
//app.config.globalProperties.$toast = useToast();
app.config.globalProperties.$errorNotification = errorNotification;

//app.use(VueAxios, axios)
app.use(require("vue-shortkey"));
//app.use(GoTop);
app.use(Toast);
app.use(store);
app.use(router).use(VueSimpleAlert);
app.use(install, {
  sitekey: "6LdBReMqAAAAAFh54dhYCcR7Pet2ZilsZPVrtIcK", // Required
  cnDomains: false, // Optional, If you use in China, set this value true
});

//.use(defineAsyncComponent)
router.isReady().then(() => app.mount("#app"));
export { app };

// <!-- Make sure you load the vue-demi first -->
// <script src="https://unpkg.com/vue-demi@0.12.1/lib/index.iife.js"></script>

// <!-- Then load vue-recaptcha -->
// <script src="https://unpkg.com/vue-recaptcha@^2/dist/vue-recaptcha.js"></script>
// <!-- Minify -->
// <script src="https://unpkg.com/vue-recaptcha@^2/dist/vue-recaptcha.min.js"></script>

// add these scripts

// const

//Fontawesome: https://stackoverflow.com/questions/66389974/using-font-awesome-in-vue-3
